"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuthFlow } from "../auth-flow-context";
import { AuthCredentialKind, AuthMethodId } from "../types";
import React, { useEffect, useState } from "react";
import { ResetPasswordForm } from "@/components/reset-password-form";
import { Button, Input, Label } from "@/components/ui";
import { cx } from "@/lib/tailwind-utils";
import { authService } from "@/services/auth-service";
export interface PasswordMethodProps {
  resetPasswordTenant?: string;
  signUpHref?: string;
  onSignUp?: () => void;
  signUpLabel?: string;
}
export function PasswordMethod(t0) {
  const $ = _c(61);
  const {
    resetPasswordTenant,
    signUpHref,
    signUpLabel,
    onSignUp
  } = t0;
  const {
    state,
    actions,
    meta
  } = useAuthFlow();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isResetPassword, setIsResetPassword] = useState(false);
  const isActive = state.activeMethod === AuthMethodId.PASSWORD;
  let t1;
  let t2;
  if ($[0] !== actions || $[1] !== isActive || $[2] !== isResetPassword) {
    t1 = () => {
      if (!isResetPassword || !isActive) {
        return;
      }
      return () => actions.setInSubFlow(false);
    };
    t2 = [actions, isActive, isResetPassword];
    $[0] = actions;
    $[1] = isActive;
    $[2] = isResetPassword;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  if (!isActive) {
    return null;
  }
  const isPending = state.runningMethod === AuthMethodId.PASSWORD;
  const errorMessage = state.errors[AuthMethodId.PASSWORD];
  const otherIsPending = state.runningMethod !== null && state.runningMethod !== AuthMethodId.PASSWORD;
  let t3;
  if ($[5] !== actions) {
    t3 = () => {
      setIsResetPassword(true);
      actions.setInSubFlow(true);
    };
    $[5] = actions;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const enterReset = t3;
  let t4;
  if ($[7] !== actions) {
    t4 = () => {
      setIsResetPassword(false);
      actions.setInSubFlow(false);
    };
    $[7] = actions;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const leaveReset = t4;
  if (isResetPassword) {
    let t5;
    if ($[9] !== resetPasswordTenant) {
      t5 = resetPasswordTenant && <div className="space-y-2 text-center"><h2 className="text-h3 font-medium">Forgot your password?</h2><p className="text-body text-foreground-secondary">Enter your email and we'll send you a reset link.</p></div>;
      $[9] = resetPasswordTenant;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    const t6 = resetPasswordTenant ? "Send reset email" : undefined;
    const t7 = resetPasswordTenant ? "Sending..." : undefined;
    const t8 = resetPasswordTenant ? "user@example.com" : "user@company.com";
    const t9 = !!resetPasswordTenant;
    let t10;
    if ($[11] !== email || $[12] !== leaveReset || $[13] !== onSignUp || $[14] !== resetPasswordTenant || $[15] !== signUpHref || $[16] !== t6 || $[17] !== t7 || $[18] !== t8 || $[19] !== t9) {
      t10 = <ResetPasswordForm initialEmail={email} tenant={resetPasswordTenant} onBack={leaveReset} signUpHref={signUpHref} onSignUp={onSignUp} submitButtonText={t6} loadingText={t7} placeholder={t8} submitButtonFullWidth={t9} />;
      $[11] = email;
      $[12] = leaveReset;
      $[13] = onSignUp;
      $[14] = resetPasswordTenant;
      $[15] = signUpHref;
      $[16] = t6;
      $[17] = t7;
      $[18] = t8;
      $[19] = t9;
      $[20] = t10;
    } else {
      t10 = $[20];
    }
    let t11;
    if ($[21] !== t10 || $[22] !== t5) {
      t11 = <div className="space-y-6">{t5}{t10}</div>;
      $[21] = t10;
      $[22] = t5;
      $[23] = t11;
    } else {
      t11 = $[23];
    }
    return t11;
  }
  let t5;
  if ($[24] !== actions || $[25] !== email || $[26] !== meta || $[27] !== password) {
    t5 = async e => {
      e.preventDefault();
      const attempt = actions.startAttempt(AuthMethodId.PASSWORD, "credential");
      const user = await actions.runAuth(AuthMethodId.PASSWORD, () => authService.login(email, password), attempt);
      if (user) {
        await meta.onSuccess({
          kind: AuthCredentialKind.PASSWORD,
          user
        }, attempt);
      }
    };
    $[24] = actions;
    $[25] = email;
    $[26] = meta;
    $[27] = password;
    $[28] = t5;
  } else {
    t5 = $[28];
  }
  const onSubmit = t5;
  let t6;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Label htmlFor="auth-email">Email</Label>;
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  let t7;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = e_0 => setEmail(e_0.target.value);
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  let t8;
  if ($[31] !== email) {
    t8 = <div className="space-y-1">{t6}<Input type="email" id="auth-email" name="email" autoComplete="email" placeholder="user@company.com" value={email} onChange={t7} /></div>;
    $[31] = email;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  let t9;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Label htmlFor="auth-password">Password</Label>;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  let t10;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = cx("h-auto p-0 text-caption-strong text-link", "hover:bg-transparent hover:text-link-hover");
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  let t11;
  if ($[35] !== enterReset) {
    t11 = <div className="flex items-center justify-between">{t9}<Button type="button" variant="ghost" size="sm" onClick={enterReset} className={t10}>Forgot password?</Button></div>;
    $[35] = enterReset;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = e_1 => setPassword(e_1.target.value);
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  const t13 = !!errorMessage;
  const t14 = errorMessage || undefined;
  let t15;
  if ($[38] !== password || $[39] !== t13 || $[40] !== t14) {
    t15 = <Input type="password" id="auth-password" name="password" autoComplete="current-password" placeholder={"\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022"} value={password} onChange={t12} hasError={t13} errorMessage={t14} />;
    $[38] = password;
    $[39] = t13;
    $[40] = t14;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] !== t11 || $[43] !== t15) {
    t16 = <div className="space-y-1">{t11}{t15}</div>;
    $[42] = t11;
    $[43] = t15;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] !== isPending || $[46] !== otherIsPending) {
    t17 = <Button variant="primary" type="submit" className="w-full" isLoading={isPending} loadingText="Signing in..." disabled={otherIsPending}>Sign in</Button>;
    $[45] = isPending;
    $[46] = otherIsPending;
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  let t18;
  if ($[48] !== onSubmit || $[49] !== t16 || $[50] !== t17 || $[51] !== t8) {
    t18 = <form onSubmit={onSubmit} className="space-y-4">{t8}{t16}{t17}</form>;
    $[48] = onSubmit;
    $[49] = t16;
    $[50] = t17;
    $[51] = t8;
    $[52] = t18;
  } else {
    t18 = $[52];
  }
  let t19;
  if ($[53] !== onSignUp || $[54] !== signUpHref || $[55] !== signUpLabel || $[56] !== state.runningMethod) {
    t19 = (onSignUp || signUpHref) && <div className="mt-6 text-center"><p className="text-body text-foreground-secondary"><span>{signUpLabel ?? "Don't have an account?"}</span>{" "}{onSignUp ? <button type="button" onClick={onSignUp} className="font-semibold text-link hover:text-link-hover hover:underline" disabled={state.runningMethod !== null}>Sign up</button> : <a href={signUpHref} className={cx("font-semibold text-link", "hover:text-link-hover underline-offset-2 hover:underline")}>Sign up</a>}</p></div>;
    $[53] = onSignUp;
    $[54] = signUpHref;
    $[55] = signUpLabel;
    $[56] = state.runningMethod;
    $[57] = t19;
  } else {
    t19 = $[57];
  }
  let t20;
  if ($[58] !== t18 || $[59] !== t19) {
    t20 = <>{t18}{t19}</>;
    $[58] = t18;
    $[59] = t19;
    $[60] = t20;
  } else {
    t20 = $[60];
  }
  return t20;
}